import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=7207df79&scoped=true&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=7207df79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7207df79",
  null
  
)

export default component.exports